import SEO from '../Client/Components/SEO';
import Scripts from '../Client/Components/Scripts';
import InnerPage from '../Client/Components/Layout/InnerPage';

function RefundCancellationPolicy(props) {
  return (
    <div>
      <SEO
        title="Refund & Cancellation Policy"
        desc="Create an account for free. Free forever. No payment needed. 1LinsApp is a free and elegant link-in-bio tool for creators. Claim your name in less than a minute!"
      />
      <Scripts chatWidget={true} beamer={false} />
      <div className="container">
        <ol>
          <li>
            If the Attendee purchases a plan, he/she acknowledges and agree that their subscription will automatically renew and the Creator will charge them on a recurring basis until they cancel
            their subscription and such cancellation is effective, which may not be until the next billing cycle.
          </li>

          <li>
            If your subscription is set for auto-renewal at the end of each billing cycle, the subscription may be cancelled by changing your account settings. For Attendee paying through any
            third-party applications, the subscription may be cancelled by modifying the relevant options in the respective third-party applications. Additionally, you may contact qoohoo customer care
            or address an email to connect@1links.app. Upon 1LinksApp receiving an email or an intimation with a request for cancellation of subscription to any plan, 1LinksApp shall duly deactivate
            the auto- renewal feature.
          </li>

          <li>Following any cancellation, you will continue to have access to the service through the end of your current billing cycle.</li>

          <li>
            If the subscription availed by the Attendee is a paid plan/subscription,
            <em>
              <strong> the Attendee shall not be eligible for any refund upon cancellation or non-use.</strong>
            </em>
          </li>

          <li>
            Even if you choose not to use your subscription, you will continue to have access to the Service through the end of your current billing cycle. The non-use of the services post availing a
            subscription does not entail you to a refund for the whole or part of the un-used subscription
          </li>

          <li>
            While availing any of the payment method/s available on the Platform, we will not be responsible to refund,, whatsoever in respect of any loss or damage arising directly or indirectly to
            You due to:
            <ol>
              <ul>
                <li>Lack of authorization for any transaction/s, or</li>
              </ul>
              <ul>
                <li>Exceeding the preset limit mutually agreed by you and between &quot;Bank/s&quot;, or</li>
              </ul>
              <ul>
                <li>Any payment issues arising out of the transaction, or</li>
              </ul>
              <ul>
                <li>Decline of transaction for any other reason/s</li>
              </ul>
            </ol>
          </li>
          <li>
            Transactions, Transaction Price and all commercial terms are as per principal to principal bipartite contractual obligations between Attendee and Creator and payment facility is merely
            used by the Attendee and Creator to facilitate the completion of the Transaction. Use of the payment facility shall not render 1LinksApp liable or responsible for the non-delivery,
            non-receipt, non-payment, breach of representations and warranties, or fraud as regards the services listed on 1LinksApp&apos;s Platform.
          </li>

          <li>
            You, as a Attendee, shall electronically notify Payment Facility using the appropriate 1LinksApp Platform features immediately upon Delivery or non Delivery within the time period as
            provided in Policies. Non-notification by You of Delivery or non Delivery within the time period specified in the Policies shall be construed as a deemed Delivery in respect of that
            Transaction. Attendee is not required to confirm the receipt of services.
          </li>

          <li>
            You, as a Attendee, shall be entitled to claim a refund of the Transaction Price (as Your sole and exclusive remedy) in case You do not receive the Delivery within the time period agreed
            in the Transaction or within the time period as provided in the Policies (Forty Eight hours), whichever is earlier.
            <em>
              <strong> In case you do not raise a refund claim using Platform features within the stipulated time than this would make You ineligible for a refund.</strong>
            </em>
          </li>

          <li>
            You, as a Attendee, understand that the Payment Facility may not be available in full or in part for certain category of services and/or Transactions as mentioned in the Policies and hence
            You may not be entitled to a refund in respect of the Transactions for those services.
          </li>

          <li>Refund, if any, shall be made at the same Issuing Bank from where Transaction Price was received, or through any other method available on the Platform, as chosen by You.</li>

          <li>Refunds, if any, will be made via electronic payment transfers.</li>

          <li>Refund shall be made in the same currency in which Attendee has paid and shall be equivalent to the Transaction Price received by the payment gateway.</li>

          <li>
            For electronics payments, refund shall be made through payment facility using NEFT / RTGS or any other online banking / electronic funds transfer system approved by Reserve Bank India
            (RBI).
          </li>

          <li>
            Refunds may be supported for select banks. Where a bank is not supported for processing refunds, You will be required to share alternate bank account details with us for processing the
            refund.
          </li>

          <li>Refund shall be conditional and shall be with recourse available to 1LinksApp in case of any misuse by Attendee.</li>

          <li>We may also request you for additional documents for verification.</li>

          <li>Refund shall be subject to Attendee complying with Policies.</li>

          <li>
            Please note that if you delete your account, you will lose access to paid time and services left in your subscription. During the deletion process, you explicitly agree to forfeit the
            remaining time and services in your current paid subscription and acknowledge that you won&rsquo;t be refunded for the Service
          </li>

          <li>These terms are to be read in line with the Terms and Conditions available [here]. All defined terms have the same meaning as stated in the Terms and Conditions.</li>
        </ol>
      </div>
    </div>
  );
}

RefundCancellationPolicy.getLayout = function getLayout(page) {
  return <InnerPage title="Refund & Cancellation Policy">{page}</InnerPage>;
};

export default RefundCancellationPolicy;
